import React from 'react';
import Carousel from 'react-material-ui-carousel'

export default function CommonCarousel({ children, onChange }) {
  return (
    <Carousel
      indicators
      // navButtonsAlwaysInvisible
      autoPlay={false}
      onChange={(index) => onChange(index)}
    >
      {children}
    </Carousel>
  )
}

CommonCarousel.defaultProps = ({
  indicators: false,
})
